import React, { Component } from 'react';
import { connect } from 'react-redux';
import io from "socket.io-client";
import API, {apiURL, AUTH_HEADER_ROOMS} from 'base/api';
import RoomsHeader from '../components/RoomsHeader';
import RoomsBody from '../components/RoomsBody';
import { fetchUserData } from 'modules/User/redux/fetchUserData';
import { fetchRoomData } from 'modules/User/redux/fetchRoomData';
import { updateRoom } from 'modules/User/redux/updateRoom';
import auth from 'base/auth';
import { leaveRoom } from 'modules/User/redux/leaveRoom';

const TOKEN = '$2a$08$Zt1W9CheTpsAZxoVw7dfs.HFg4Tcs55RTcvG4mZ8IMqj0lnjCsX3O';

const SOCKET_ROOM_EVENT = 'roomEvent';
const SOCKET_GET_ROOMS = 'getRooms';

class RoomsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rooms: []
    };

    this.socket = io(apiURL);
    this.socket.on(SOCKET_ROOM_EVENT, (rooms) => {
      // console.log('Socket - rooms', rooms);
      console.log('updated')
      this.updateRooms(rooms);
    });
    this.socket.emit(SOCKET_GET_ROOMS);
  }

  updateRooms = (rooms) => {

    // var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
    // console.log(rooms.sort(collator.compare));
    if (this.localeCompareSupportsLocales()) {
      this.setState({rooms: rooms.sort( (a,b) => a.roomName.localeCompare(b.roomName, undefined, {numeric: true}))});
    } else {
      this.setState({rooms: rooms});
    }
  }

  localeCompareSupportsLocales = () => {
    try {
      'foo'.localeCompare('bar', 'i');
    } catch (e) {
      return e.name === 'RangeError';
    }
    return false;
  }

  handleTakeRoom = (e) => {
    const { dispatch } = this.props;
    const id = e.target.id;
    dispatch(fetchRoomData(id));
  }

  handleRoomLeave = (id) => {
    // console.log(id)
    this.props.dispatch(leaveRoom());
  }

  handleSaveRoom = (roomId, indexes) => {
    // console.log("ROOM ID", roomId)
    // console.log("INDEKSY", indexes)
    this.props.dispatch(updateRoom(roomId, {newRoomers: indexes}));
  }

  componentWillUnmount = () => {
    this.socket.disconnect();
  }

  render() {
    const { user, room } = this.props;
    const { rooms } = this.state;

    return (
      <div className="rooms-wrapper">
        <RoomsHeader
          firstName={user.firstName}
          surname={user.surname}
          room={user.room}
          onRoomLeave={() => this.handleRoomLeave(user.room ? user.room._id : undefined)}
          // onRoomLeave={() => toast('tset')}
        />

        <RoomsBody
          rooms={rooms}
          yourIndex={user.index}
          singleRoom={room}
          onTakeRoom={this.handleTakeRoom}
          onSaveRoom={ (roomId, indexes) => this.handleSaveRoom(roomId, indexes)}
          actualRoom={auth.getActualRoom()}
        />
      </div>
    )
  }
};

export default connect(
  state => ({room: state.room})
)(RoomsView);



// WEBPACK FOOTER //
// ./src/modules/User/views/RoomsView.js